import { Affix, Grid } from 'antd';
import { type ReactNode, useMemo } from 'react';

interface AffixWrapperProps {
    responsive?: boolean;
    offsetTop?: number;
    children: ReactNode;
}

const AffixWrapper = ({ responsive = false, offsetTop = 80, children }: AffixWrapperProps) => {
    const screens = Grid.useBreakpoint();
    const isMobile = useMemo(() => !screens.lg, [screens]);

    if (!responsive || !isMobile) {
        return <Affix offsetTop={offsetTop}>{children}</Affix>;
    }

    return children as React.ReactElement;
};

export default AffixWrapper;
